






















import {Component, Vue} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

import {TaxRefund} from '@/store/modules/taxrefund/types'
import toCurrency from '@/filters/to-currency'
import {Done} from '@/icons'

const taxrefund = namespace('taxrefund')

@Component({
  components: {
    Done
  }
})
export default class RequestCompleted extends Vue {
  @taxrefund.State('taxrefund') taxrefund?: TaxRefund

  get conservativeTaxRefund(): number {
    const {refundPerYear} = this.taxrefund as TaxRefund
    const totalRefundAmount = Math.floor(refundPerYear.reduce((prev, curr) => curr.amount + prev, 0))
    return totalRefundAmount
  }

  toCurrencyValue(value, hasFilter?: boolean) {
    return toCurrency(value, hasFilter)
  }
}
